import React,{useState} from 'react'
import { Link } from 'react-router-dom'

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/scss/modal-video.scss'

export default function VideoModalTwo() {
    let [isOpen, setOpen] = useState(false);
  return (
    <>
        <div className="play-icon">
                {/* <Link to="#" onClick={() => setOpen(true)} className={`video-play-icon lightbox watch mb-2 ${textLight ? 'text-white title-dark' : 'text-dark'}`}><i className="mdi mdi-play play-icon-circle text-center d-inline-block me-2 rounded-pill text-white title-dark position-relative play play-iconbar"></i> Watch Video !</Link> */}
             
            <Link to="#" onClick={() => setOpen(true)} className="lightbox play-btn video-play-icon">
                <i className="mdi mdi-play mdi-18px text-primary rounded-circle bg-white shadow"></i>
            </Link>
        </div> 
        <ModalVideo
            channel="youtube"
            youtube={{ mute: 0, autoplay: 0 }}
            isOpen={isOpen}
            videoId="04leqUzjrh4"
            onClose={() => setOpen(false)} 
        />
    </>
  )
}
